import React from 'react'

import Icon from '../static/icon'

import styles from './buttonIconWrapper.module.scss'

const getClassName = type => {
  switch (type) {

    case 'green':
      return styles.buttonIconWrapper_green
    case 'primary':
      return styles.buttonIconWrapper_primary
    case 'secondary':
      return styles.buttonIconWrapper_secondary
    default:
      return styles.buttonIconWrappe
  }
}

const ButtonIconWrapper = props => {
  const { type, icon, disabled, handleClick } = props

  return (
    <button className={getClassName(type)} onClick={handleClick} disabled={disabled}>
      <Icon name={icon} />
    </button>
  )
}

export default React.memo(ButtonIconWrapper)